import React, {useEffect, useRef, useState} from 'react';
import ProductCard, {Touchpoint} from '@wishlist/components/product-card/ProductCard.jsx';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import Breakpoint from '@core/scripts/helper/breakpoint';
import {SliderTypes} from './slider-types.js';
import RecommendationUtils from './recommendation-utils.js';
import SliderLandmarkHelper from '@core/scripts/components/tracking/landmarks/slider-landmark-helper';

const GAP = 16;

export default function OutfitContent({outfit, landmarkData}) {
    if (!outfit) {
        return null;
    }

    const containerRef = useRef(null);
    const [productCardWidth, setProductCardWidth] = useState(0);
    const [padding, setPadding] = useState(Breakpoint.keyIsIn(['small']) ? 20 : 0);

    const calculateProductCardWidth = () => {
        // Calculate the width of the product card based on the width of the parent element
        // we have to do this, otherwise the Product Card layout in the Side Sheet will be broken
        const parentElement = containerRef.current.parentElement;
        const totalPadding = padding * 2;
        setProductCardWidth((parentElement.offsetWidth - totalPadding) / 2 - (GAP / 2));
        setPadding(Breakpoint.keyIsIn(['small']) ? 20 : 0);
    };

    useEffect(() => {
        if (containerRef.current) {
            calculateProductCardWidth();
        }

        const subscription = MessageBroker.subscribe(Messages.WINDOW.RESIZED, calculateProductCardWidth);

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const onItemClicked = (event, clickedItem) => {
        event.preventDefault();
        SliderLandmarkHelper.createAndSendOutfitItemProductCardClickedLandmark(SliderTypes.OUTFITS, clickedItem, landmarkData, outfit.assetId);
        RecommendationUtils.navigateToTargetWithRecommendationTypeOrigin('outfits', clickedItem.productLink);
    };

    const {recommendationProductCardItems} = outfit;

    return (
        <div ref={containerRef} style={{display: 'flex', flexFlow: 'row wrap', gap: GAP + 'px', padding: `0 ${padding}px`}}>
            {productCardWidth ? recommendationProductCardItems?.map((item, index) => (
                <div style={{width: productCardWidth + 'px'}} key={'outfit-content-item-' + index}
                     onClick={(event) => onItemClicked?.(event, item)}>
                    <ProductCard item={item} touchpoint={Touchpoint.RECOMMENDATION}/>
                </div>
            )) : null}
        </div>
    )
}